/* tslint:disable */
/* eslint-disable */
/**
 * Distributor API
 * The Cashlink Distributor API enables you to distribute crypto securities and digital securities. It contains all building blocks from investor registration and KYC/AML to brokerage, clearing and settlement processes. While you are in full control of the frontends served to your investors you can use the Cashlink Studio to monitor and manage the activity on your platform.   Note: You cannot access data of investors or investments if they haven\'t been created via the API with your provided API credentials. Also, it\'s not possible to access data of investors that have registered via the Cashlink Signing Module, if you are using this as well.  ### Authentication  Every call to the API must be authenticated via OAuth client credentials. During setup, your point of contact will provide you with your client ID and client secret.   ### Idempotency  For certain POST endpoints, the API uses client-supplied idempotency keys to ensure that requests can be retried safely without performing the same operation twice. Repeated calls to those endpoints with the same idempotency key will return the cached response from the first call. Keys are expected to be set as header parameters with *X-Idempotency-Key*. The recommended approach for interacting with such endpoints is as follows:   - Create a unique, random key, such as a UUIDv4.   - Store the intent to call an endpoint along with the generated key in the client database.   - Flush to disk (e.g. commit an SQL transaction).   - Perform the call to the endpoint.   This ensures that even if the response from the API to a client gets lost, or the client experiences any sort of outage between steps 3 and 4, the client can always safely retry the same action.   If you already have objects corresponding to tasks in the API in your client-side database, you can use their internal IDs as idempotency keys!   ### Monetary values   Monetary values are represented as a combination of amount, decimals & currency. For example, ```{\'amount\': \'40000000\', \'decimals\': 3, \'currency\': \'EUR\'} means \'EUR 40,000.000\'```.   ### Handling documents  The document endpoint can be used to upload documents. Files are uploaded via HTTP multipart. The endpoint will return a document ID that can be used in other requests to refer to that document.   ### Webhooks  You can also register webhooks so that we can notify your application about events with regards to investments. To use that, please provide your point of contact at Cashlink with the following data:   - URL to be used as the target for webhooks  - OAuth client credentials or bearer authentication token so that we can authenticate at your server.  Webhooks are sent every time the status of an investment changes.  **POST <customer-provided URL>**  Webhooks are retried until the called endpoint returns a 2xx.  **Request**  {  \'investment_id\': \'3fa85f64-5717-4562-b3fc-2c963f66afa6\',  \'status\': \'ACCEPTED\',  \'changed_at\': \'2020-12-11T14:59:46.716Z\'  }  ### Concepts  The Cashlink Distributor API is based on the following concepts:  - Persons (legal or natural) that are users on your platform willing to invest are called investors.  - These investors will be able to invest into different financial products issued by different entities. In the API they are called products.  - The purchase of units of such a product takes place within your application and ends with a signed investment contract.  - Now you can create an investment, which contains the investor, the units, the signed investment contract and the accepted date of the investment by the issuer.   - At some point, parts of the investments are returned to the issuer because the outstanding amount has been paid back for example. Such a transaction is called a redemption.    
 *
 * The version of the OpenAPI document: v2
 * Contact: support@cashlink.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const CurrencyEnum = {
    ADP: 'ADP',
    AFA: 'AFA',
    ALK: 'ALK',
    AON: 'AON',
    AOR: 'AOR',
    ARA: 'ARA',
    ARP: 'ARP',
    ATS: 'ATS',
    AZM: 'AZM',
    BAD: 'BAD',
    BEF: 'BEF',
    BGL: 'BGL',
    BRC: 'BRC',
    BRE: 'BRE',
    BRN: 'BRN',
    BRR: 'BRR',
    BYR: 'BYR',
    CLE: 'CLE',
    CSD: 'CSD',
    CSK: 'CSK',
    CYP: 'CYP',
    DDM: 'DDM',
    DEM: 'DEM',
    ECS: 'ECS',
    ECV: 'ECV',
    EEK: 'EEK',
    ESA: 'ESA',
    ESB: 'ESB',
    ESP: 'ESP',
    FIM: 'FIM',
    FRF: 'FRF',
    GHC: 'GHC',
    GRD: 'GRD',
    GWP: 'GWP',
    HRD: 'HRD',
    IEP: 'IEP',
    ITL: 'ITL',
    LTL: 'LTL',
    LUF: 'LUF',
    LVL: 'LVL',
    MGF: 'MGF',
    MLF: 'MLF',
    MRO: 'MRO',
    MTL: 'MTL',
    MZM: 'MZM',
    NLG: 'NLG',
    PEI: 'PEI',
    PLZ: 'PLZ',
    PTE: 'PTE',
    ROL: 'ROL',
    RUR: 'RUR',
    SDD: 'SDD',
    SIT: 'SIT',
    SKK: 'SKK',
    SRG: 'SRG',
    STD: 'STD',
    TJR: 'TJR',
    TMM: 'TMM',
    TPE: 'TPE',
    TRL: 'TRL',
    UAK: 'UAK',
    USS: 'USS',
    VEB: 'VEB',
    VEF: 'VEF',
    VNN: 'VNN',
    XEU: 'XEU',
    YDD: 'YDD',
    YUM: 'YUM',
    YUN: 'YUN',
    ZAL: 'ZAL',
    ZMK: 'ZMK',
    ZRN: 'ZRN',
    ZRZ: 'ZRZ',
    ZWD: 'ZWD',
    ZWL: 'ZWL',
    ZWR: 'ZWR',
    AOK: 'AOK',
    ARL: 'ARL',
    ARM: 'ARM',
    BAN: 'BAN',
    BEC: 'BEC',
    BEL: 'BEL',
    BGM: 'BGM',
    BGO: 'BGO',
    BOL: 'BOL',
    BOP: 'BOP',
    BRB: 'BRB',
    BRZ: 'BRZ',
    BUK: 'BUK',
    BYB: 'BYB',
    CNH: 'CNH',
    CNX: 'CNX',
    GEK: 'GEK',
    GNS: 'GNS',
    GQE: 'GQE',
    GWE: 'GWE',
    ILP: 'ILP',
    ILR: 'ILR',
    ISJ: 'ISJ',
    KRH: 'KRH',
    KRO: 'KRO',
    LTT: 'LTT',
    LUC: 'LUC',
    LUL: 'LUL',
    LVR: 'LVR',
    MAF: 'MAF',
    MCF: 'MCF',
    MDC: 'MDC',
    MKN: 'MKN',
    MRU: 'MRU',
    MTP: 'MTP',
    MVP: 'MVP',
    MXP: 'MXP',
    MZE: 'MZE',
    NIC: 'NIC',
    PES: 'PES',
    RHD: 'RHD',
    SDP: 'SDP',
    STN: 'STN',
    SUR: 'SUR',
    UGS: 'UGS',
    UYP: 'UYP',
    UYW: 'UYW',
    VES: 'VES',
    XRE: 'XRE',
    YUD: 'YUD',
    YUR: 'YUR',
    AED: 'AED',
    AFN: 'AFN',
    ALL: 'ALL',
    AMD: 'AMD',
    ANG: 'ANG',
    AOA: 'AOA',
    ARS: 'ARS',
    AUD: 'AUD',
    AWG: 'AWG',
    AZN: 'AZN',
    BAM: 'BAM',
    BBD: 'BBD',
    BDT: 'BDT',
    BGN: 'BGN',
    BHD: 'BHD',
    BIF: 'BIF',
    BMD: 'BMD',
    BND: 'BND',
    BOB: 'BOB',
    BOV: 'BOV',
    BRL: 'BRL',
    BSD: 'BSD',
    BTN: 'BTN',
    BWP: 'BWP',
    BYN: 'BYN',
    BZD: 'BZD',
    CAD: 'CAD',
    CDF: 'CDF',
    CHE: 'CHE',
    CHF: 'CHF',
    CHW: 'CHW',
    CLF: 'CLF',
    CLP: 'CLP',
    CNY: 'CNY',
    COP: 'COP',
    COU: 'COU',
    CRC: 'CRC',
    CUC: 'CUC',
    CUP: 'CUP',
    CVE: 'CVE',
    CZK: 'CZK',
    DJF: 'DJF',
    DKK: 'DKK',
    DOP: 'DOP',
    DZD: 'DZD',
    EGP: 'EGP',
    ERN: 'ERN',
    ETB: 'ETB',
    EUR: 'EUR',
    FJD: 'FJD',
    FKP: 'FKP',
    GBP: 'GBP',
    GEL: 'GEL',
    GHS: 'GHS',
    GIP: 'GIP',
    GMD: 'GMD',
    GNF: 'GNF',
    GTQ: 'GTQ',
    GYD: 'GYD',
    HKD: 'HKD',
    HNL: 'HNL',
    HRK: 'HRK',
    HTG: 'HTG',
    HUF: 'HUF',
    IDR: 'IDR',
    ILS: 'ILS',
    IMP: 'IMP',
    INR: 'INR',
    IQD: 'IQD',
    IRR: 'IRR',
    ISK: 'ISK',
    JMD: 'JMD',
    JOD: 'JOD',
    JPY: 'JPY',
    KES: 'KES',
    KGS: 'KGS',
    KHR: 'KHR',
    KMF: 'KMF',
    KPW: 'KPW',
    KRW: 'KRW',
    KWD: 'KWD',
    KYD: 'KYD',
    KZT: 'KZT',
    LAK: 'LAK',
    LBP: 'LBP',
    LKR: 'LKR',
    LRD: 'LRD',
    LSL: 'LSL',
    LYD: 'LYD',
    MAD: 'MAD',
    MDL: 'MDL',
    MGA: 'MGA',
    MKD: 'MKD',
    MMK: 'MMK',
    MNT: 'MNT',
    MOP: 'MOP',
    MUR: 'MUR',
    MVR: 'MVR',
    MWK: 'MWK',
    MXN: 'MXN',
    MXV: 'MXV',
    MYR: 'MYR',
    MZN: 'MZN',
    NAD: 'NAD',
    NGN: 'NGN',
    NIO: 'NIO',
    NOK: 'NOK',
    NPR: 'NPR',
    NZD: 'NZD',
    OMR: 'OMR',
    PAB: 'PAB',
    PEN: 'PEN',
    PGK: 'PGK',
    PHP: 'PHP',
    PKR: 'PKR',
    PLN: 'PLN',
    PYG: 'PYG',
    QAR: 'QAR',
    RON: 'RON',
    RSD: 'RSD',
    RUB: 'RUB',
    RWF: 'RWF',
    SAR: 'SAR',
    SBD: 'SBD',
    SCR: 'SCR',
    SDG: 'SDG',
    SEK: 'SEK',
    SGD: 'SGD',
    SHP: 'SHP',
    SLE: 'SLE',
    SLL: 'SLL',
    SOS: 'SOS',
    SRD: 'SRD',
    SSP: 'SSP',
    SVC: 'SVC',
    SYP: 'SYP',
    SZL: 'SZL',
    THB: 'THB',
    TJS: 'TJS',
    TMT: 'TMT',
    TND: 'TND',
    TOP: 'TOP',
    TRY: 'TRY',
    TTD: 'TTD',
    TVD: 'TVD',
    TWD: 'TWD',
    TZS: 'TZS',
    UAH: 'UAH',
    UGX: 'UGX',
    USD: 'USD',
    USN: 'USN',
    UYI: 'UYI',
    UYU: 'UYU',
    UZS: 'UZS',
    VED: 'VED',
    VND: 'VND',
    VUV: 'VUV',
    WST: 'WST',
    XAF: 'XAF',
    XAG: 'XAG',
    XAU: 'XAU',
    XBA: 'XBA',
    XBB: 'XBB',
    XBC: 'XBC',
    XBD: 'XBD',
    XCD: 'XCD',
    XDR: 'XDR',
    XFO: 'XFO',
    XFU: 'XFU',
    XOF: 'XOF',
    XPD: 'XPD',
    XPF: 'XPF',
    XPT: 'XPT',
    XSU: 'XSU',
    XTS: 'XTS',
    XUA: 'XUA',
    YER: 'YER',
    ZAR: 'ZAR',
    ZMW: 'ZMW',
    ZWN: 'ZWN'
} as const;
export type CurrencyEnum = typeof CurrencyEnum[keyof typeof CurrencyEnum];


export function instanceOfCurrencyEnum(value: any): boolean {
    for (const key in CurrencyEnum) {
        if (Object.prototype.hasOwnProperty.call(CurrencyEnum, key)) {
            if (CurrencyEnum[key as keyof typeof CurrencyEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function CurrencyEnumFromJSON(json: any): CurrencyEnum {
    return CurrencyEnumFromJSONTyped(json, false);
}

export function CurrencyEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): CurrencyEnum {
    return json as CurrencyEnum;
}

export function CurrencyEnumToJSON(value?: CurrencyEnum | null): any {
    return value as any;
}

